import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Alert } from '@guildeducationinc/recess';
import { AlertContent } from '@guildeducationinc/recess/components/Alert/AlertContent';
import { formatParams, useLocale } from 'pe-core-frontend';
export const DeadlineErrorMessages = ({ messages }) => {
    const { t, intl } = useLocale();
    return (messages &&
        messages
            .filter(error => error?.params?.title)
            .map((error, index) => (_jsx(Alert, { display: true, type: 'warning', hideClose: true, children: _jsx(AlertContent, { children: _jsxs("div", { className: 'flex flex-col', children: [_jsx("div", { children: _jsx("b", { children: t(error.params?.title) }) }), _jsx("div", { children: _jsx("div", { children: t(error.value, {
                                    values: formatParams(intl, error.params),
                                }) }) })] }) }) }, index))));
};
